import { Component, Input } from '@angular/core';
import { ChartComponent } from "ng-apexcharts";

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart
} from "ng-apexcharts";

export type PieChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions:any;
  colors: any;
};

@Component({
  selector: 'app-lcv-by-property-charts',
  templateUrl: './lcv-by-property-charts.component.html',
  styleUrls: ['./lcv-by-property-charts.component.scss']
})
export class LcvByPropertyChartsComponent {

  @Input() selectedToggle: string = '';
  @Input() public chartOptionsYear: PieChartOptions | null = null;
  @Input() public chartOptionsType: PieChartOptions | null = null;
}
